import { Pipe, PipeTransform } from '@angular/core';
import { Roles } from '@uw/core/enums/role.enum';
import { KeyValueModel } from '@uw/core/models/keyvalue.model';

@Pipe({ name: 'roleName' })
export class RoleNamePipe implements PipeTransform {
  transform(item: Roles | null | undefined ): any {
    if (!item)
      return '';
    switch(item) {
      case Roles.ReportAdministrator:
        return 'Report Administrator';
      case Roles.WorkspaceAdministrator:
        return 'Workspace Administrator';
      case Roles.UnitedWayAdministrator:
        return 'UnitedWay Administrator';
      default:
        return 'User';
    }
  }
}
